<template>
	<b-container>
      <b-row class="justify-content-center">

        <b-col md="8" class="p-0">
          <div class="checkout-container"></div>
        </b-col>

        <b-col md="4" class="d-flex flex-column bg-primary pb-2 mb-2">
          <b-alert class="mt-2" v-if="errorMessage" variant="danger"  show dismissible>{{ errorMessage }}</b-alert>

        
            <b-alert class="mt-2" v-if="getSavingStatus[0] && udadTransactionId==''" :variant="getSavingStatus[2]"  show dismissible>{{ getSavingStatus[1] }}</b-alert>

            <div v-show="!getSavingStatus[0] && isCheckoutCompleted && udadTransactionId==''" class="text-center">
              <p>Your Account Setup in Progress! Don't Close this page, Please Wait ...</p>
              <h3><b-icon icon="arrow-clockwise" font-scale="2" animation="spin-pulse" variant="light"></b-icon></h3>  
            </div>




            <div v-show="!getSavingStatus[0] && isCheckoutCompleted && udadTransactionId!=''" class="text-center">
              <p>Your Balance Update in Progress! Don't Close this page, Please Wait 5 seconds...</p>
              <h3><b-icon icon="arrow-clockwise" font-scale="2" animation="spin-pulse" variant="light"></b-icon></h3>  
            </div>

            <div v-show="getSavingStatus[0] && isCheckoutCompleted && udadTransactionId!=''" class="text-center">
              <p>{{ getSavingStatus[1] }}</p> 
            </div>

            
            <div v-show="isUdadCanceled" class="text-center">
              <p>Payment Failed or Canceled! You can close this web page safely.</p> 
            </div>




            <b-button v-show="isCheckoutCompleted && udadTransactionId==''" :disabled="!getSavingStatus[0]"  @click="onSpeechorLogin" variant="warning" class="mt-2">Login Page</b-button>
            <b-button v-show="isCheckoutCompleted && udadTransactionId==''" :disabled="!getSavingStatus[0]"  @click="onBackToPricing" variant="warning" class="mt-2">Back to Pricing</b-button>
            <b-button v-show="isCheckoutCompleted && udadTransactionId==''" :disabled="!getSavingStatus[0]"  @click="onContactUs" variant="warning" class="mt-2">Contact Us</b-button>
        
            <div v-show="this.udadTransactionId=='' && this.token==''">
              <div v-show="!isCheckoutCompleted">
                <h3>Items</h3>
                <b-table
                    class="text-light"
                    show-empty
                    striped
                    primary
                    small
                    stacked="md"
                    ref="tableRef"
                    :items="itemsArray"
                    :fields="fieldsItems" 
                  > 

                  <template #cell(totalprice)="row">
                    <div>${{ row.value }}</div>
                  </template>
                </b-table>
                
                <h3>Totals</h3>
                <b-table
                    class="text-light"
                    show-empty
                    striped
                    primary
                    small
                    stacked
                    ref="tableRef"
                    :items="totalsArray"
                    :fields="fieldsTotals" 
                  >
                  <template #cell(recurringTotal)="row">
                    <div>${{ row.value }} (per {{billingInterval}})</div>
                  </template>
                  <template #cell(discountTotal)="row">
                    <div>${{ row.value }}</div>
                  </template>
                  <template #cell(taxTotal)="row">
                    <div>${{ row.value }}</div>
                  </template>
                  <template #cell(totalToday)="row">
                    <div><b>${{ row.value }}</b></div>
                  </template>
                </b-table>
              </div>
            </div>

            <div v-show="this.udadTransactionId!='' && this.token!='' && !isUdadCanceled">
              <div v-show="!isCheckoutCompleted">
                <h3>Details</h3>
                <b-table
                    class="text-light"
                    show-empty
                    striped
                    primary
                    small
                    stacked
                    ref="tableRef"
                    :items="UdadTotalsArray"
                    :fields="fieldsUdadTotals" 
                  >
                  <template #cell(price)="row">
                    <div>{{ row.value }}</div>
                  </template>
                  <template #cell(recurringTotal)="row">
                    <div>${{ row.value }}</div>
                  </template>
                  <template #cell(discountTotal)="row">
                    <div>${{ row.value }}</div>
                  </template>
                  <template #cell(taxTotal)="row">
                    <div>${{ row.value }}</div>
                  </template>
                  <template #cell(total)="row">
                    <div><b>${{ row.value }}</b></div>
                  </template>
                </b-table>
              </div>
            </div>
           
            <b-button v-show="!isCheckoutCompleted && udadTransactionId==''" @click="switchPlan" variant="secondary" class="mb-4">Switch to {{ notSelectedPlan }} Plan</b-button>
            <b-button v-show="!isCheckoutCompleted && udadTransactionId==''" @click="onCancel" variant="secondary" class="mt-auto">- Cancel -</b-button>
           
          
            <b-button v-show="!isCheckoutCompleted && udadTransactionId!='' && UdadTotalsArray.length>0" @click="onCancelUdad" variant="secondary" class="mt-auto">- Cancel Boost -</b-button>
         

        </b-col>
      </b-row>
	</b-container> 
</template>

<script>
  import { mapGetters } from "vuex";
export default {
 
  data() {
    return {
      paddle: window.Paddle,
      paddleToken: 'live_95a0d264e9d71513759ec1dd23b',
      billingCycle: 'month',
      cancelUrl: '',
      udadTransactionId: null,
      token: null,
      currency: null,
      redirectUrl: 'https://speechorapp.univerhome.com',
      monthItemsList:[],
      yearItemsList:[],
      isMonthly: true,
      itemsArray: [],
      fieldsItems: [
          { key: 'price', label: 'Package'},
          { key: 'quantity', label: 'Quantity'},
          { key: 'totalprice', label: 'Total'},
        ],
      totalsArray: [],
      fieldsTotals: [
          { key: 'recurringTotal', label: 'Billing cycle charges'},
          { key: 'discountTotal', label: 'Discount'},
          { key: 'taxTotal', label: 'Taxes'},
          { key: 'totalToday', label: 'Total Today'},
        ],
      UdadTotalsArray:[],
      fieldsUdadTotals: [
          { key: 'price', label: 'Name'},
          { key: 'recurringTotal', label: 'Amount'},
          { key: 'discountTotal', label: 'Discount'},
          { key: 'taxTotal', label: 'Taxes'},
          { key: 'total', label: 'Total'},
        ],
      notSelectedPlan: '',
      billingInterval: '',
      isCheckoutCompleted:false,
      errorMessage:'',
      isUdadCanceled: false
    };
  },

  computed: {
    ...mapGetters(["getSavingStatus"])
  },

  mounted(){

    this.$store.dispatch("initialize");

    this.monthItemsList = [{ priceId: this.$route.query.mp, quantity: 1}];
    this.yearItemsList = [{ priceId: this.$route.query.ap, quantity: 1}];
    this.billingCycle = this.$route.query.bc;
    this.cancelUrl = this.$route.query.curl;
    this.udadTransactionId = this.$route.query.tsn || '';
    this.token = this.$route.query.tkn || '';
    this.currency = this.$route.query.currency || '';

    if(this.udadTransactionId!='' && this.token!=''){
      this.paddle.Environment.set("sandbox");
      this.paddleToken = "test_6e29fe93f736b11a9d7ec625f09";
      this.$store.dispatch("updateCheckoutFor");
    }

    //console.log("params:", this.udadTransactionId, this.token)
    //enable envirenment for dev sandbox only
    
    //sandbox token
    //token: "test_6e29fe93f736b11a9d7ec625f09" 
    //token: "live_95a0d264e9d71513759ec1dd23b"
 
    const callUpdateTable = (event) => {
      this.errorMessage='';
      this.updateTable(event);
    }

    this.paddle.Initialize({
      token: this.paddleToken,
      checkout: {
                  settings: {
                              displayMode: "inline",
                              frameTarget: "checkout-container",
                              frameInitialHeight: "450",
                              frameStyle: "width: 100%; min-width: 312px; background-color: #ffffff; border: none;",
                              variant: 'one-page',
                              showAddDiscounts: true,
                              locale: 'en'
                  }
      },
      eventCallback: callUpdateTable
    }); 

    if(this.udadTransactionId!='' && this.token!=''){
      this.openUdadCheckout(this.udadTransactionId);
    }else{
      if (this.billingCycle == 'year'){
        this.openCheckout(this.yearItemsList);
      } else {
        this.openCheckout(this.monthItemsList);
      }
    }

    
    

  },

  methods:{
    onCancel(){
      this.paddle.Checkout.close();
      window.location.replace(this.cancelUrl);
    },

    onCancelUdad(){
      this.paddle.Checkout.close();
      this.UdadTotalsArray = [];
      this.isUdadCanceled = true;
      window.location.href = "udad://driver_wallet?message=payment_failed_canceled";
    },

    onBackToPricing(){
      window.location.replace(this.cancelUrl);
    },

    onSpeechorLogin(){
      window.location.replace(this.redirectUrl);
    },

    onContactUs(){
      this.$router.push("/Askus");
    },

    // open checkout
   openCheckout(items){
      this.paddle.Checkout.open({
        items: items
      });
    },

    //open Udad checkout

    openUdadCheckout(tsnId){
      this.paddle.Checkout.open({
        transactionId: tsnId
      });
    },

    switchPlan() {
      this.itemsArray = [];
      this.totalsArray= [];
      let updatedItems = this.isMonthly ? this.yearItemsList : this.monthItemsList;
      this.paddle.Checkout.updateCheckout({
        items: updatedItems
      });
      this.isMonthly = !this.isMonthly;
    },

    updateTable(event) {
      if (!event.name) {
        return;
      }


      //take all customer information from this event and add it to Speechor users table db
      if (event.name == 'checkout.completed') {
        //dispatch save new checkout data
        this.isCheckoutCompleted = true;
        //important! address should be collected by me, the get it from this event.data.customer.address
        if(this.udadTransactionId=='' && this.token==''){
          setTimeout(() => {
            this.$store.dispatch("SavePaddleSubscription", { transactionId: event.data.transaction_id,
                                                    email: event.data.customer.email});
          }, 7000);

          this.$analytics.fbq.event('SuccessPayment', {currency: "USD", value: 9.99});
          this.$gtag.event('conversion', {
              'send_to': 'AW-710213325/ZJq_CLfs4_sCEM3909IC',
              'value': 9.99,
              'currency': 'USD',
              'transaction_id': ''
          });
        }
        else{
          //console.log(event)
          setTimeout(() => {
            this.$store.dispatch("SaveUdadBoostTransaction", { 
              transactionId: event.data.transaction_id,
              status: event.data.status,
              method: event.data.payment.method_details.type, 
              token: this.token, 
              amount: event.data.totals.total,
              currency: this.currency
            });
          }, 5000);
          
        }
         
      }

      if (event.name == 'checkout.payment.failed') {
        
        if(this.udadTransactionId!='' && this.token!=''){
          this.onCancelUdad();
          
        }else{
          //show error detail to the customer
          this.errorMessage='Payment failed! verify if your payment method is active and has enough credit for the checkout amount, then try again!'
        }
      }

      if (event.name == 'checkout.error') {
        if(this.udadTransactionId!='' && this.token!=''){
            this.onCancelUdad();
        }else{
          this.errorMessage= event?.error?.code + ': ' + event?.error?.detail;
        }
      } 
      
      const updateDetailsArrayEvents = ['checkout.loaded', 'checkout.updated'];
      if(updateDetailsArrayEvents.includes(event.name)){
        //console.log(event)
        let items = event.data.items;
        if(this.udadTransactionId!='' && this.token!=''){
            this.updateUdadTable(items, event.data.totals);
        }else{
          this.updateItemsTable(items);
          this.updateSummaryTable(event.data.totals, event.data.recurring_totals);
        }
      }
      
      
    },

    updateItemsTable(items) {
      this.itemsArray = [];
      items.forEach(item => {
        const rObj = {};
        rObj.price = item.price_name;
        rObj.quantity = item.quantity;
        rObj.totalprice = item.recurring_totals.total.toFixed(2);    
        this.itemsArray.push(rObj);
        this.billingInterval = item.billing_cycle.interval;
        this.notSelectedPlan = this.billingInterval == "month" ? "Annually" : "Monthly";
      });

    },

    updateSummaryTable(totals, recurringTotals) {
      this.totalsArray = [];
      const tObj = {};
        tObj.recurringTotal = recurringTotals.subtotal.toFixed(2);
        tObj.discountTotal = totals.discount.toFixed(2);
        tObj.taxTotal =  totals.tax.toFixed(2);
        tObj.totalToday = totals.total.toFixed(2);      
        this.totalsArray.push(tObj);
    },

    updateUdadTable(items, totals) {
      this.UdadTotalsArray = [];
      const tObj = {};
        tObj.price = items[0].price_name;
        tObj.recurringTotal = totals.balance.toFixed(2);
        tObj.discountTotal = totals.discount.toFixed(2);
        tObj.taxTotal =  totals.tax.toFixed(2);
        tObj.total = totals.total.toFixed(2);      
        this.UdadTotalsArray.push(tObj);
    },

  },

};
</script>
<style scoped>
</style>